import { render, staticRenderFns } from "./ModelInstances.vue?vue&type=template&id=28048bc6&scoped=true"
import script from "./ModelInstances.vue?vue&type=script&lang=js"
export * from "./ModelInstances.vue?vue&type=script&lang=js"
import style0 from "./ModelInstances.vue?vue&type=style&index=0&id=28048bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28048bc6",
  null
  
)

export default component.exports